import styled from "styled-components"

import {Para} from "@irati/ui/src/Labels"
import {Modal} from "react-bootstrap"
import {greys, perkbox} from "@irati/ui/src/global/colors"
import {twoPxShadowBigBlur} from "@irati/ui/src/global/elevation"
import {WaitImage} from "../styled"

interface TabProps {
  selected?: boolean
}

export const Tab = styled.div<TabProps>`
  ${({selected}) => selected && twoPxShadowBigBlur}
  cursor: pointer;
  display: flex;
  flex-direction: column;
  align-items: center;
  border: ${({selected}) => (selected ? perkbox.blue : greys.light)} 1px solid;
  border-radius: 10px;
  padding: 30px 15px;
  width: 48%;
  position: relative;
`

export const SelectedCard = styled.div`
  position: absolute;
  width: 20px;
  height: 20px;
  bottom: -31px;
  left: 50%;
  border-top: 1px solid ${greys.light};
  border-left: 1px solid ${greys.light};
  background-color: ${greys.white};
  transform: rotate(45deg);
`

export const OptionTitle = styled(Para)`
  max-width: 100%;
  margin: 0;
`

export const OptionDescription = styled(Para)`
  max-width: 100%;
`

export const ContentWrapper = styled.div`
  padding: 30px;
  padding-top: 60px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
`

export const CloseWrapper = styled.div`
  position: relative;
`

export const WaitImageAbsolute = styled(WaitImage)`
  position: absolute;
  top: -50px;
  margin-left: auto;
  margin-right: auto;
  left: 0;
  right: 0;
`

export const CustomModal = styled(Modal)`
  .custom-dialog {
    margin-top: calc(50vh - 200px);
  }
`
